import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // SECURITY: Password is hashed to prevent trivial bypass
  // To change password: node -e "const crypto = require('crypto'); console.log(crypto.createHash('sha256').update('YOUR_PASSWORD' + 'lyman-studios-salt-2024').digest('hex'));"
  const CORRECT_PASSWORD_HASH = '2e98a8b6a0ec688a8f6aa23b247506df48ae72f667c146e44c2bab3b72599908';
  const AUTH_KEY = 'site_authenticated';

  // Simple hash function (for demo - use bcrypt in production)
  const hashPassword = async (password) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password + 'lyman-studios-salt-2024');
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  };

  useEffect(() => {
    // Check if user is already authenticated
    const authenticated = sessionStorage.getItem(AUTH_KEY);
    if (authenticated === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    // Preload persistent HubSpot Meetings iframe once for faster subsequent opens
    if (document.getElementById("hs-meetings-iframe")) return;
    const host = document.createElement("div");
    host.id = "hs-meetings-iframe-host";
    host.style.position = "fixed";
    host.style.width = "0";
    host.style.height = "0";
    host.style.overflow = "hidden";
    host.style.opacity = "0";
    host.style.pointerEvents = "none";
    const iframe = document.createElement("iframe");
    iframe.id = "hs-meetings-iframe";
    iframe.src = "https://meetings-na2.hubspot.com/brian-wilkinson?embed=true";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.minWidth = "312px";
    iframe.style.minHeight = "615px";
    iframe.style.border = "none";
    iframe.style.overflow = "hidden";
    iframe.style.overscrollBehavior = "contain";
    iframe.style.display = "block";
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("data-hs-ignore", "true");
    iframe.addEventListener(
      "load",
      () => {
        iframe.dataset.loaded = "true";
      },
      { once: true }
    );
    host.appendChild(iframe);
    document.body.appendChild(host);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const hash = await hashPassword(password);

      if (hash === CORRECT_PASSWORD_HASH) {
        sessionStorage.setItem(AUTH_KEY, 'true');
        setIsAuthenticated(true);
        setError('');
        // Redirect to home page after successful authentication
        setTimeout(() => {
          navigate('/home');
        }, 500);
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
    } catch (err) {
      setError('Authentication error. Please try again.');
      setPassword('');
    }
  };

  const openConsultationModal = (e) => {
    e.preventDefault();
    // mount HubSpot Meetings widget (modal overlay)
    if (!document.getElementById("MeetingsEmbedCode-js")) {
      const s = document.createElement("script");
      s.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.async = true;
      s.defer = true;
      s.id = "MeetingsEmbedCode-js";
      document.body.appendChild(s);
    }
    let overlay = document.getElementById("hs-meetings-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "hs-meetings-overlay";
      overlay.className = "fixed inset-0 z-[60] flex justify-center items-start p-0 bg-[#425B76] md:bg-black/50";
      overlay.style.overflow = "hidden";
      overlay.style.overscrollBehavior = "contain";

      const inner = document.createElement("div");
      inner.className = "relative w-screen h-screen md:w-full md:max-w-4xl md:h-[90vh] bg-[#425B76] md:bg-transparent rounded-none shadow-none p-0";
      inner.style.overflow = "hidden";

      // Loader placeholder
      const loader = document.createElement("div");
      loader.className = "flex items-center justify-center h-full text-muted-foreground";
      loader.innerHTML = '<div class="animate-pulse">Loading…</div>';

      // Obtain persistent iframe
      let iframe = document.getElementById("hs-meetings-iframe");
      if (!iframe) {
        // Fallback: create if missing
        iframe = document.createElement("iframe");
        iframe.id = "hs-meetings-iframe";
        iframe.src = "https://meetings-na2.hubspot.com/brian-wilkinson?embed=true";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.minWidth = "312px";
        iframe.style.minHeight = "0";
        iframe.style.border = "none";
        iframe.style.overflow = "hidden";
        iframe.style.overscrollBehavior = "contain";
        iframe.style.display = "block";
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("data-hs-ignore", "true");
        iframe.addEventListener(
          "load",
          () => {
            iframe.dataset.loaded = "true";
            loader.style.display = "none";
          },
          { once: true }
        );
      }
      // Mobile-only stretch to remove inner gutters without blurring
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (isMobile) {
        iframe.style.position = "absolute";
        iframe.style.width = "110vw";
        iframe.style.height = "110vh";
        iframe.style.left = "-5vw";
        iframe.style.top = "-5vh";
      } else {
        iframe.style.position = "static";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.left = "0";
        iframe.style.top = "0";
      }

      // Mount area for iframe
      const mount = document.createElement("div");
      mount.className = "h-full";
      if (iframe.dataset.loaded === "true") loader.style.display = "none";
      mount.appendChild(loader);
      mount.appendChild(iframe);
      inner.appendChild(mount);

      const close = document.createElement("button");
      close.className = "fixed top-4 right-4 md:absolute md:top-[21px] md:right-[27px] z-[70] text-gray-500 hover:text-gray-900 bg-white hover:bg-white/80 rounded";
      close.innerText = "×";
      close.style.fontSize = "18px";
      close.style.lineHeight = "1";
      close.style.margin = "0";
      close.style.padding = "2px 9px";
      close.style.paddingBottom = "6px";
      close.onclick = () => {
        // Move iframe back to host to persist load
        const host =
          document.getElementById("hs-meetings-iframe-host") ||
          (() => {
            const h = document.createElement("div");
            h.id = "hs-meetings-iframe-host";
            h.style.position = "fixed";
            h.style.width = "0";
            h.style.height = "0";
            h.style.overflow = "hidden";
            h.style.opacity = "0";
            h.style.pointerEvents = "none";
            document.body.appendChild(h);
            return h;
          })();
        if (iframe && host) host.appendChild(iframe);
        document.body.style.overflow = "";
        overlay.remove();
      };
      inner.appendChild(close);

      overlay.appendChild(inner);
      document.body.appendChild(overlay);
      document.body.style.overflow = "hidden";
    }
  };

  // If authenticated, redirect to home page
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo/Brand Section - Matching site style */}
        <div className="text-center mb-8">
          <h1 className="text-5xl md:text-6xl font-brand tracking-wide text-white mb-4">
            <span className="text-white">Lyman</span>
            <span className="text-[#B08D57]">.Studios</span>
          </h1>
          <p className="text-gray-400 text-sm mt-2">Fine Art Photography</p>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20">
          {/* Password Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                Enter Password to Access Site
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#B08D57] focus:border-transparent transition duration-200"
                placeholder="Enter password"
                autoComplete="off"
              />
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-3">
                <p className="text-red-400 text-sm text-center">{error}</p>
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-[#B08D57] hover:bg-[#9A7A4A] text-white font-semibold py-3 px-6 rounded-lg transition duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#B08D57] focus:ring-offset-2 focus:ring-offset-gray-900"
            >
              Access Site
            </button>
          </form>

          {/* Additional Info */}
          <div className="mt-6 pt-6 border-t border-white/10">
            <button
              onClick={openConsultationModal}
              className="w-full bg-white/5 hover:bg-white/10 text-white font-medium py-2.5 px-6 rounded-lg transition duration-200 border border-white/20 hover:border-[#B08D57]"
            >
              Contact Us
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Lyman.Studios. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
